import { X } from "lucide-react";

export const pInput = "w-full min-w-0 rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none placeholder:text-zinc-500 focus:border-white/40";
export const ghostBtn = "flex items-center gap-1.5 rounded-full border border-white/15 px-3.5 py-2 text-xs font-semibold text-zinc-100 transition-colors hover:bg-white/10 disabled:opacity-40";

const TAG = { estoque: "Estoque", manual: "À mão", tabela: "Tabela" };

// Linhas editáveis (aparelho + valor). Usada no "Você leva" e no "Aparelho na troca".
export const ItemRows = ({ items, valueKey, onChange, testid, placeholder }) => {
  const set = (i, patch) => onChange(items.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  if (!items.length) return null;
  return (
    <ul className="mt-3 space-y-2">
      {items.map((x, i) => (
        <li key={i} data-testid={`${testid}-row-${i}`} className="grid grid-cols-[1fr_auto] gap-2 sm:grid-cols-[1fr_150px_auto]">
          <div className="relative col-span-2 sm:col-span-1">
            <input data-testid={`${testid}-label-${i}`} value={x.label} maxLength={140} placeholder={placeholder} onChange={(e) => set(i, { label: e.target.value })} className={`${pInput} pr-16`} />
            <span className="mono pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[10px] uppercase tracking-wider text-zinc-400">{TAG[x.source]}</span>
          </div>
          <input data-testid={`${testid}-value-${i}`} inputMode="decimal" value={x[valueKey]} placeholder="R$ 0,00"
            onChange={(e) => set(i, { [valueKey]: e.target.value.replace(/[^\d.,]/g, "").slice(0, 12) })} className={`${pInput} text-right`} />
          <button type="button" data-testid={`${testid}-remove-${i}`} aria-label="Remover" onClick={() => onChange(items.filter((_, j) => j !== i))}
            className="flex h-9 w-9 items-center justify-center self-center rounded-full border border-white/15 text-zinc-300 hover:bg-white/10"><X className="h-4 w-4" /></button>
        </li>
      ))}
    </ul>
  );
};
